import UseAxios from '../../Api/http/http';
import { getCertificationsCategoryList } from '../../Api/request/certificationCategoryMaster';
import { logError } from '../../Utils/logger';

export const fetchCertificationCategoryList = async () => {
  try {
    const response = await UseAxios((getCertificationsCategoryList()));
    const activeCategories = await response.data.certificationCategoryDetails.filter(
      (item) => item.isActive,
    );

    // Group subcategories based on category
    const groupedCategories = await activeCategories.reduce((acc, item) => {
      const { categoryId, categoryName, subCategoryId, subCategoryName } = item;
      if (!acc[categoryId]) {
        acc[categoryId] = {
          id: categoryId,
          name: categoryName,
          subCategories: [],
        };
      }
      acc[categoryId].subCategories.push({
        id: subCategoryId,
        name: subCategoryName,
      });
      return acc;
    }, {});


    // Convert groupedCategories object to an array
    const result = Object.values(groupedCategories);

    return result;
  } catch (error) {
    logError(error);
    return [];
  }
};
